<template>
  <div class="record">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item
          style="float: right; margin-right: 0 "
        >
          <el-button
            class="table-set"
            @click="exportTable('stockOrderRecordExport')"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
           ref="column"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('crm_record.ji_shen_hao')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
         <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
         <el-form-item :label="$t('crm_record.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_record.she_bei_lei_xing')">
          <custom-select v-model="formSearch.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('crm_record.ku_cun_fang')">
          <el-input style="width:100%;" v-model="formSearch.orgName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        v-if="funcView.crm_stock_record_list"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :tableCode="tableCode"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['stockStartNum']"
      >
        <template v-slot:stockStartNum="scope">
          <span
            class="check-detail"
            @click="checkDeliverGoodsInfo(scope.row)"
          >{{scope.row.orderCode}}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      >
      </custom-page>
    </div>
    <deliver-goods-info-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      :model="dialogModel1"
    ></deliver-goods-info-dialog>
  </div>
</template>

<script>
/** 库存记录 */

import apis from '@/utils/apis';
import deliverGoodsInfoDialog from '@/pages/crm/components/deliver_goods_info_dialog';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: {
    deliverGoodsInfoDialog,
  },
  props: {},
  data() {
    return {
      tableCode: 'crm_stock_record',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        search: '',
        productCode: '',
        deviceBizType: '',
        orgName: ''
      },
      tableList: [],
      totalRows: null,
      // 发货详情
      dialogVisible1: false,
      dialogModel1: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.stockOrderRecordPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    checkDeliverGoodsInfo(row) {
      this.dialogModel1 = {
        data: {
          customShipmentNum: row.stockStartNum,
        },
        title: this.$t('crm_record.fa_huo_xiang_qing')
      };
      this.dialogVisible1 = true;
    },
  },
  created() { },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/crmStock/manage');
    this.getTableList();
  },
};
</script>

<style lang="scss" scoped>
.record {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-left: 16px;
  padding-top: 16px;

  .check-detail {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
